import React from "react";
import LoginForm from "./LoginForm";

const SignIn = () => {
  return (
    <div>
      <LoginForm />
    </div>
  );
};

export default SignIn;
